/** Standard CMS branch ID (OASIS M0016 info -9140): XXQXXXX999 */
export const CMS_STANDARD_BRANCH_ID = /^[0-9A-Z]{2}Q[0-9A-Z]{4}[0-9]{3}$/;
